import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { changeLanguage } from '@shared';
import { APP_LANGS } from '@shared/lib/i18n';
import { useTranslation } from 'next-i18next';

export const LangSwitcher = () => {
  const { i18n } = useTranslation();

  return (
    <FormControl variant="standard">
      <Select id="lang-select" value={i18n.language}>
        {APP_LANGS.map((lng) => (
          <MenuItem
            key={lng}
            disabled={i18n.language === lng}
            value={lng}
            onClick={() => changeLanguage({ i18n, lng })}
          >
            {lng}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
